import { DetailViewCard } from '../../../Compounds/CardWithTitle';
import { Team } from '../../../../store/Team';
import { TeamManagerGridColumnDefs } from '../ColumnDefs/TeamManagerGridColumnDefs';
import { useNavigate } from 'react-router-dom';
import { adminUrlForRole } from '../../../../store/User';
import { TextColor } from '../../../Atoms/Text';
import DropdownMenu from '../../../Compounds/Menu/DropdownMenu';
import { MemberActions } from './MemberDropdown';
import { initAddUsersToTeamForm } from '../../../../store/AddPortalUsersToTeamFormState';
import { BasicDataGrid } from '../../../Compounds/Table/BasicDataGrid';
import { TeamDrawerPermissionSetSection } from '../../../Compounds/PermissionSets/TeamDrawerPermissionSetSection';

export interface TeamDetailsProps {
  data: Team;
}

export function TeamDetails({ data }: TeamDetailsProps) {
  const navigate = useNavigate();

  const createUserOption = {
    title: 'Create New User',
    fontColor: 'indigo' as TextColor,
    onClick: () => navigate(`${adminUrlForRole()}/new-user`)
  };
  const promoteUserOption = {
    title: 'Promote Existing User',
    fontColor: 'indigo' as TextColor,
    onClick: () => {
      initAddUsersToTeamForm(data.id, 'manager');
      navigate('/admin/teams/add-managers');
    }
  };
  // Promotion grants the client Team Manager role, which has no place on an internal team.
  const managerMenuOptions = data.practice ? [createUserOption] : [createUserOption, promoteUserOption];

  const managerActions = () => {
    return (
      <DropdownMenu
        icon="plus"
        buttonText="Add Team Manager"
        buttonTextColor="grey12"
        options={managerMenuOptions}
        slotProps={{
          paper: {
            style: {
              width: 175
            }
          }
        }}
      />
    );
  };

  return (
    <div className="w-11/12 m-auto">
      <DetailViewCard
        title={'Team Managers'}
        cardActions={managerActions()}
        enableCollapse={false}>
        <BasicDataGrid
          rows={data.team_managers}
          columns={TeamManagerGridColumnDefs}
          dataCy="team-detail-team-managers-table"
        />
      </DetailViewCard>
      <DetailViewCard
        title={'Team Members'}
        cardActions={MemberActions({ teamId: data.id })}
        enableCollapse={false}>
        <BasicDataGrid
          rows={data.team_members}
          columns={TeamManagerGridColumnDefs}
          dataCy="team-detail-team-members-table"
        />
      </DetailViewCard>
      <TeamDrawerPermissionSetSection team={data} />
    </div>
  );
}
